import { createSelector } from '@reduxjs/toolkit';
import { eventOccurrencesNotDeleted } from '../events/event-occurrences-not-deleted';
import { now } from '../organization/now';
import { todoListHideAfterDaysOption } from '../todo-list';
import { LocalDate } from '../../../utilities/local-date';

export const unscheduledEventOccurrences = createSelector(
  eventOccurrencesNotDeleted,
  now,
  todoListHideAfterDaysOption,
  (occurrences, t, hideAfterDays) => {
    const excludeDoneTasksBefore = t.minusDays(hideAfterDays);
    return occurrences.filter(
      (e) =>
        (e.date === null || e.date === undefined) &&
        (!e.doneDate || LocalDate.fromString(e.doneDate).isAfter(excludeDoneTasksBefore)),
    );
  },
);
